<template>
  <header class="fixed-top">
    <b-navbar type="dark" class="nav-up" toggleable="lg">
      <b-navbar-nav class="ml-auto">
        <b-nav-text
          style="font-size: 14px;"
          v-tooltip.bottom="user?user.sigBanco.nombre_abr:'' || ''"
        >Portal Transacional - Bienvenido(a) {{getUserName || ''}} &nbsp; &nbsp; | &nbsp; &nbsp;</b-nav-text>
        <b-nav-item to="/mensajes">► Mis mensajes</b-nav-item>
        <b-nav-item to="/cambio-pass">► Cambio de contraseña</b-nav-item>
        <b-nav-item @click="onCerrar()">► Cerrar sesión</b-nav-item>
      </b-navbar-nav>
    </b-navbar>

    <!-- para que las lineas del header sean mas delgadas line-height:7%; -->
    <div class="container2">
      <b-navbar toggleable="lg" class="nav-down">
        <b-navbar-brand href="/home">
          <!-- /images/logo_sig_white_transp.png -->
          <img src="/images/logo1.svg" alt="FGA" id="logo" />
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item to="/carga">Cargue de archivos</b-nav-item>
            <b-nav-item to="/informes">Informes</b-nav-item>
            <b-nav-item to="/productos">Productos</b-nav-item>
            <b-nav-item to="/novedades">Reporte de novedades</b-nav-item>
            <b-nav-item to="/estado-procesos">Estado de procesos</b-nav-item>

            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template slot="button-content">Utilidades</template>
              <b-dropdown-item to="/descargas">Descargas</b-dropdown-item>
              <b-dropdown-item to="/glosario">Glosario</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderComponet",
  data() {
    return {};
  },
  methods: {
    async onCerrar() {
      this.$store.dispatch("user/logout");
      this.$router.go("/login");
    }
  },
  computed: {
    getUserName: function() {
      return this.$store.state.user.user
        ? this.$store.state.user.user.nombres +
            " " +
            this.$store.state.user.user.apellidos
        : "";
    },
    user() {
      return this.$store.state.user.user;
    }
  }
};
</script>



